import React from 'react';
import Survey, { CssNames } from '../../../Survey';
import DemographicsSurvey from './demographics';
import DemographicsWrapper from './demographics.styles';

const parsedBirth = birth => {
  // birth comes as DD/MM/AAAA
  const [day, month, year] = birth.split('/');
  // return as year-month-day as standard
  return `${year}-${month}-${day}`;
};

class Demographics extends React.Component {
  // state = { stage: 0, big5: null, matrix: null };
  //Define a callback methods on survey complete

  onComplete = async (survey, options) => {
    // Write survey results into database
    // console.log('Survey results: ');
    // const { data } = survey;
    // console.log(data);
    // await this.setState(prev => ({ big5: data, stage: prev.stage + 1 }));
    const { onComplete } = this.props;

    const { data } = survey;
    const { NAME_BASE, BIRTH } = data;
    const parsed = {
      ...data,
      BIRTH: parsedBirth(BIRTH),
      ...NAME_BASE
    };
    // if gen on user data, use as SEX field.
    if (data.gen) {
      parsed.SEX = data.gen;
      parsed.GEN = data.gen;
    }
    if (data.sex) { // meaning if user has sex field from list
      parsed.SEX_BASE = data.sex;
    }
    delete parsed.NAME_BASE;

    await onComplete(parsed);
  };

  onValidate = async survey => {
    const { data } = survey;
    // if not consent, submit early
    if (data.CONSENT === '2') {
      const { onComplete } = this.props;
      const parsed = {
        ...data
      };
      await onComplete(parsed);
    }
  };

  render() {
    const DemographicsModel = new Survey.Model(DemographicsSurvey);
    DemographicsModel.data = this.props.initialData || {};
    return (
      <DemographicsWrapper>
        <div className='edu_header'>
          {/* <img
            className='edu-logo'
            src='https://res.cloudinary.com/dpveipnvx/image/upload/v1564630271/uaimetrics/uai_white.png'
            alt='edu-logo'
          /> */}
        </div>
        <Survey.Survey
          model={DemographicsModel}
          css={CssNames}
          onComplete={this.onComplete}
          onValidatedErrorsOnCurrentPage={this.onValidate}
        />
        {/* <div className='Footer'>

        </div> */}
        {/* <div className='PushStickyFooter'></div> */}
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </DemographicsWrapper>
    );
  }
}

export default Demographics;
